import "../../App.css";
import Sidebar from "../Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";
function Direccion(props) {
  const { history } = props;
  const [DireccionStateUpdate, setDireccionStateUpdate] = useState([]);
  const [DireccionState, setDireccionState] = useState([]);
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(false);
  // eslint-disable-next-line
  const [formularioUpdate, setformularioUpdate] = useState({});
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  useEffect(() => {
    async function llamadaApi() {
      let response = await fetch(
        Parametros.urlApi + "address_units?skip=0&limit=100&is_mantenedor=true",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        let responseJson = await response.json();

        let responseJsonUpdate = JSON.stringify(responseJson);
        let responseJsonstate = JSON.stringify(responseJson);

        setDireccionStateUpdate(JSON.parse(responseJsonUpdate));
        setDireccionState(JSON.parse(responseJsonstate));
      } else if (response.status === Parametros.loginTokenExcept) {
        alert(Parametros.loginTokenExceptMessage);
        history.push({
          pathname: "/",
        });
      }
    }

    llamadaApi();
  }, [update, usuario, history]);

  const [formularioState, setFormularioState] = useState({
    name: "",
  });

  const [editable, setEditable] = useState({
    id: "",
  });
  let handleStageForm = (e) => {
    const value = e.target.value ? e.target.value : e.currentTarget.innerText;
    const name = e.target.getAttribute("name");

    //
    setFormularioState({
      ...formularioState,
      [name]: value,
    });
  };
  let crearDireccion = async (event) => {
    event.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let response = await fetch(Parametros.post + "address_units/", {
          method: "POST",
          body: JSON.stringify(formularioState),
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
        });
        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert("se creo correctamente");
          setUpdate(!update);

          document.getElementById("formularioBusqueda").reset();
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert("error al crear");
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.crear);
    }
  };

  let confirmarEdicion = async (item) => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        let updateitem = {
          name: item.name,
        };

        let response = await fetch(
          Parametros.urlApi + "address_units/" + parseInt(item.address_unit_id),
          {
            method: "PUT",
            headers: {
              Authorization: "Bearer " + usuario.key,
              Accept: "application/json",
              "Content-Type": "application/json",
              Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
            },
            body: JSON.stringify(updateitem),
          }
        );

        let responseJson = await response.json();

        if (response.status === 200 || response.status === 201) {
          alert(responseJson.message);
          setEditable({});
          setUpdate(!update);
        } else if (response.status === Parametros.loginTokenExcept) {
          alert(Parametros.loginTokenExceptMessage);
          history.push({
            pathname: "/",
          });
        } else {
          alert(responseJson.detail);
          setDireccionState(JSON.parse(JSON.stringify(DireccionStateUpdate)));
        }
      } else {
        // Do nothing!
        setEditable({});
        // setpersonaEmpresaState(JSON.parse(JSON.stringify(personaEmpresaStateUpdate)))
      }
    } else {
      alert(usuario.editar);
    }
  };
  let cancelarEdicion = () => {
    const nuevoObjeto = JSON.parse(JSON.stringify(DireccionStateUpdate));
    setDireccionState(nuevoObjeto);
    setEditable({});
  };
  let editar = (id) => {
    setDireccionState(JSON.parse(JSON.stringify(DireccionStateUpdate)));
    setEditable(id);
    setformularioUpdate({});
  };
  let DireccionHandleChange = (index, e) => {
    let newList = DireccionState;
    newList[index][e.target.name] = e.target.value;
    setDireccionState(JSON.parse(JSON.stringify(newList)));
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Unidad de dirección"}></UserTab>
        <form id="formularioBusqueda" onSubmit={crearDireccion}>
          <div className="col-md-4">
            <h5>Unidad de dirección</h5>
            <input
              onChange={handleStageForm}
              name="name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <Table
            type={1}
            paginationBelow={true}
            paginas={Math.max(
              1,
              Math.ceil(DireccionState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={["Unidad de dirección"]}
          ></Table>

          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Unidad de dirección"]}></Table>
            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {DireccionState.slice(
                  (paginacionState.skip - 1) * paginacionState.limit,
                  (paginacionState.skip - 1) * paginacionState.limit +
                    paginacionState.limit
                ).map((item, displayIndex) => {
                  const index =
                    (paginacionState.skip - 1) * paginacionState.limit +
                    displayIndex;
                  return (
                    <tr key={item.address_unit_id}>
                      {editable === item.address_unit_id ? (
                        <>
                          <td>{item.address_unit_id}</td>
                          <td>
                            <input
                              value={item.name}
                              name="name"
                              onChange={(event) => {
                                DireccionHandleChange(index, event);
                              }}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  confirmarEdicion(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              >
                                {" "}
                              </span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              {" "}
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  cancelarEdicion(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.address_unit_id}</td>
                          <td>{item.name} </td>
                          <td>
                            <abbr title="Editar Elemento ">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  editar(item.address_unit_id);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`address_units/${item.address_unit_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={Math.max(
              1,
              Math.ceil(DireccionState.length / paginacionState.limit)
            )}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Direccion);
